import { gql } from "@apollo/client";

import { groupFragment, singleGroupFragment, batchProperties } from "./fragment";

export const GET_GROUPS_LIST = gql`
  query GetGroupsList($businessUnitId: Int, $animalTypeIds: [Int]) {
    groupsExtended(businessUnitId: $businessUnitId, animalTypeIds: $animalTypeIds) {
      groups {
        ...batchProperties
        ...groupFragment
      }
    }
  }
  ${groupFragment}
  ${batchProperties}
`;

export const GET_GROUP_BY_ID = gql`
  query GetGroup($group: UUID!, $businessUnit: Int!) {
    group(group: $group, businessUnit: $businessUnit) {
      ...batchProperties
      ...singleGroupFragment
    }
  }
  ${singleGroupFragment}
  ${batchProperties}
`;

export const GET_BATCH_TERMS = gql`
  query GetBatchTerms {
    animalTypes {
      id
      name
      batchName {
        name
        plural
      }
    }
  }
`;

export const GET_BATCH_BY_ID = gql`
  query GetBatchById($group: UUID!, $businessUnit: Int!) {
    group(group: $group, businessUnit: $businessUnit) {
      ...batchProperties
      ...singleGroupFragment
    }
  }
  ${batchProperties}
  ${singleGroupFragment}
`;
